import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private subject = new Subject<boolean>();
  public isSpinnerVisible = this.subject.asObservable();

  public show() {
    // console.log("[spinner.service]", "show");
    this.subject.next(true);
  }

  public hide() {
    // console.log("[spinner.service]", "hide");
    this.subject.next(false);
  }
}
